<template>
    <div>
        <div v-loading="pageLoading">
			<div class="group" v-if="data">
			    <div class="page-group-title"><span>订单信息</span></div>
			    <el-card shadow="never" class="MT20">
			        <el-row :gutter="40">
			            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">订单ID: </span>{{data.id}}</el-col>
			            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">订单编号: </span>{{data.sn}}</el-col>
			            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">订单下单时间: </span>{{data.orderTime}}</el-col>
			            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">订单状态: </span>{{data.orderStatus}}</el-col>
						<el-col :xs="24" :sm="12" :md="8"><span class="color-info">下单用户: </span>{{data.buyerId}}</el-col>
						<el-col :xs="24" :sm="12" :md="8"><span class="color-info">下单终端: </span>{{data.terminal}}</el-col>
						<el-col :xs="24" :sm="12" :md="8"><span class="color-info">下单IP城市: </span>{{data.ipCity}}</el-col>
						<el-col :xs="24" :sm="12" :md="8"><span class="color-info">下单IP省份: </span>{{data.ipCity}}</el-col>
			            <el-col :xs="24" :sm="12" :md="8" v-if="data.cancelTime"><span class="color-info">订单取消时间: </span>{{data.cancelTime}}</el-col>
			        </el-row>
			     </el-card>
			</div>
			<div class="group MT20" v-if="data">
			    <div class="page-group-title"><span>用户信息</span></div>
			    <el-card shadow="never" class="MT20">
			        <el-row :gutter="40">
			            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">用户ID: </span>{{data.buyerId}}</el-col>
			            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">用户昵称: </span>{{data.buyerName}}</el-col>
			            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">用户身份: </span>{{data.buyerType}}</el-col>
			            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">用户手机号: </span>{{data.tel}}</el-col>
			        </el-row>
			     </el-card>
			</div>
			<div class="group MT20" v-if="data">
			    <div class="page-group-title"><span>支付信息</span></div>
			    <el-card shadow="never" class="MT20">
			        <el-row :gutter="40">
			            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">支付方式: </span>{{data.payMethod}}</el-col>
			            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">支付平台交易号: </span>{{data.outTradeNo}}</el-col>
			            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">支付时间: </span>{{data.payTime}}</el-col>
			            <el-col :xs="24" :sm="12" :md="8"><span class="color-info">支付金额: </span>{{data.amount}}</el-col>
			        </el-row>
			     </el-card>
			</div>
		</div>
		<div class="group MT20">
		    <el-button @click="goBack">返回</el-button></div>
    </div>
</template>

<script>

export default {
   props:{
       id: {
           type: [Number, String],
           default: () => null
       }
   },
    components:{},
    data(){
        return{
			pageLoading:false,
			data:null,
			redirect: this.$route.query.redirect || '/Members/order/list',
		}
    },
	created(){
	    if (this.id) {
	        this.getInfo();
	    }
	},
	 methods: {
		 //获取详情
		 getInfo(){
		     this.pageLoading = true;
		     this.$request({
		         url: '/member/order/detail',
		         method: "POST",
		         params: {orderId:this.id}
		     }).then(res=>{
		         const {state, msg, result} = res.data;
		         if (state == 1) {
		             this.data = result
		 			
		         } else {
		             this.$message.error(msg || "请求失败");
		         }
		     }).catch(() => {
		         this.$message.error("请求错误");
		     }).finally(()=>{
		         this.pageLoading = false;
		     })
		 },
		 //返回
		 goBack() {
		     if(this.redirect){
		         this.$router.push({
		             path: this.redirect,
		         });
		     }else{
		         this.$router.go(-1);
		     }
		 },
	 }
}
</script>
<style lang="scss" scoped>
.el-card{
    .el-col{
        line-height: 28px;
    }
}
</style>